module.exports = __webpack_public_path__ + "img/52.4692895d.jpg";